import { useState, useEffect } from "react";
import { configService, AppConfiguration } from "../../services/config";

/**
 * Hook para acceder a la configuración de la aplicación
 */
export const useAppConfig = () => {
  const [config, setConfig] = useState<AppConfiguration | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        setLoading(true);
        setError(null);
        const appConfig = await configService.getAppConfig();
        setConfig(appConfig);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Failed to load configuration"));
        console.error("Error loading app configuration:", err);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  return {
    config,
    loading,
    error,
    reload: () => {
      configService.clearCache();
      setConfig(null);
      setLoading(true);
      setError(null);
    },
  };
};

/**
 * Hook para acceder solo a la configuración de autenticación
 */
export const useAuthConfig = () => {
  const { config, loading, error } = useAppConfig();

  return {
    authConfig: config?.auth || null,
    loading,
    error,
  };
};
